//CSS
import "../../Components/Page/Page.css";
import engine from "../../Images/OurStory/Wankel.png";
import DieselGen from "../../Images/ElfTech/DieselGenorator.png";
import DieselGenReg from "../../Images/ElfTech/DieselGenoratorReg.png";

//React
import React from "react";
import SecHeader from "../../Components/SecHeader/SecHeader";
import SubSection from "../../Components/Section/SubSection";
import ImageComp from "../../Components/ImageContainer/ImageComp";

const DieselGenerator: React.FC = () => {
    return (
        <div id="Goals" className="sectionContainer">
            <SecHeader title="Diesel Generator Engines" />
            <SubSection>
                <div className="inv-items">
                    <div className="inv-item">
                        <p className="inv-item-body">
                            <ul>
                                <li>466cc - 480cc displacement</li>
                                <li>Diesel with mechanical injection</li>
                                <li>2-cylinders, 1 power stroke / rev.</li>
                                <li>Valve-timed piston scavenging</li>
                                <li>Max power = 8-kW / 11-hp.</li>
                                <li>Mechanical governor</li>
                                <li>Quiet & cool running</li>
                                <li>Low maintenance</li>
                                <li>Long lasting</li>
                            </ul>
                        </p>
                    </div>
                </div>
            </SubSection>
            <SubSection>
                <ImageComp imageSource={DieselGen} width={"Clamp(18rem, 25vw, 36rem)"} />
                <ImageComp imageSource={DieselGenReg} width={"Clamp(18rem, 25vw, 36rem)"} />
            </SubSection>
            <SubSection isSplit={true}>
                <div className="inv-items">
                    <div className="inv-item">
                        <p className="inv-item-body">
                            <h4 className="inv-item-title">Reference (72-kg)</h4>
                            <ul>
                                <li> Water cooled, 4-stroke, in-line-2 cylinder</li>
                                <li>Low over-expansion = average efficient</li>
                                <li>Max efficiency = 36%-37% (227 g/kWh)</li>
                                <li>Max average piston speed is 8 m/s</li>

                            </ul>
                        </p>
                    </div>
                </div>
                <div className="inv-items">
                    <div className="inv-item">
                        <p className="inv-item-body">
                            <h4 className="inv-item-title">LF-TechTM (24-kg)</h4>
                            <ul>
                                <li>ir cooled, valve-timed, piston scavenged
                                    2-stroke, with high balance & low vibration</li>
                                <li>140% over expansion improves emissions</li>
                                <li>Max efficiency improves to 40% (205 g/kWh)</li>
                                <li>Max average piston speed is only 5 m/s</li>
                                <li>33% of the weight -&- 33% of the Volume</li>
                                <li>50% fewer parts -&- 60% of the unit cost</li>

                            </ul>
                        </p>
                    </div>
                </div>
            </SubSection>
        </div>
    );
};

export default DieselGenerator;
